/** Who asked a simulator run, by name: the signed-in user reads as "You", nothing until names load. */

import { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { currentUserAtom } from '@/hooks/use-auth';
import { useAccountUsers } from '@/hooks/use-account-users';

export function useRunAuthor(): (userId: string | null) => string {
	const currentUser = useAtomValue(currentUserAtom);
	const { data: users } = useAccountUsers();
	return useCallback(
		(userId: string | null) => {
			if (!userId) return 'Someone';
			if (currentUser && String(currentUser.id) === userId) return 'You';
			if (!users) return '';
			return users.find((user) => String(user.id) === userId)?.name || 'A former teammate';
		},
		[currentUser, users]
	);
}
